import React, { Component } from 'react'
import injectSheet from 'react-jss'
import styles from './school-files.styles'
import SchoolFilesTable from './school-files-table/school-files-table.container'
import CurrentSkeleton from './school-files-skeleton/current-skeleton'
import SchoolFilesFilter from './school-files-filter/school-files-filter.container'
import usingmoderation from './hero-image-2.png'
import classNames from 'classnames'

class SchoolFiles extends Component {
  componentDidMount() {
    this.props.onMount()
  }
  componentDidUpdate(prevProps) {
    this.props.onUpdate(prevProps)
  }
  render() {
    const {
      classes,
      pending,
      noSchoolFiles,
      filterParams,
      restrictedFromCreatingAFs
    } = this.props
    return (
      <>
        <SchoolFilesFilter />
        <>
          {noSchoolFiles ? (
            <div>
              <img
                src={usingmoderation}
                className={classNames(classes.illustration, {
                  [classes.restricted]: restrictedFromCreatingAFs
                })}
                alt="Not Found"
              />
              {restrictedFromCreatingAFs && (
                <div>
                  <p className={classes.container}>
                    The school files area is only available to those with active
                    moderation subscriptions. From here you can view any
                    moderation files from your school,
                    <br /> including school exemplars.
                    <br />
                    <br />
                    <a
                      className={classes.link}
                      href="https://www.pobble.com/pricing-moderation"
                      target="_blank"
                      rel="noopener noreferrer">
                      Purchase a subscription
                    </a>{' '}
                    or{' '}
                    <a
                      className={classes.link}
                      href="https://www.pobble.com/webinars"
                      target="_blank"
                      rel="noopener noreferrer">
                      join a free webinar
                    </a>{' '}
                    to find out more.
                  </p>
                </div>
              )}
              {!restrictedFromCreatingAFs && (
                <div>
                  {filterParams.search_string === '' && (
                    <p className={classes.container}>
                      Nobody within your school has created and shared a
                      moderation file yet...
                      <br /> why not be the first.
                      <br />
                      <br />
                      <a
                        className={classes.link}
                        href="https://www.loom.com/share/0bc098cdd69b492db830d79e5e93c991"
                        target="_blank"
                        rel="noopener noreferrer">
                        Watch our video
                      </a>{' '}
                      and learn how you can create and <br />
                      share your first moderation files.
                      <br />
                      <br />
                      Are you an Assessment Leader or English Leader? <br />
                      <a
                        className={classes.link}
                        href="https://www.pobble.com/webinars"
                        target="_blank"
                        rel="noopener noreferrer">
                        Join our free CPD session
                      </a>{' '}
                      on using Pobble to develop effective moderation practice.
                    </p>
                  )}
                  {filterParams.search_string &&
                    filterParams.search_string !== '' && (
                      <p className={classes.container}>
                        There are no matching moderation files yet.
                      </p>
                    )}
                </div>
              )}
            </div>
          ) : pending ? (
            <CurrentSkeleton />
          ) : (
            <SchoolFilesTable />
          )}
        </>
      </>
    )
  }
}

export default injectSheet(styles)(SchoolFiles)
